<template>
  <div id="return_step_1">
    <div class="head_wrap">
      <div class="order_info">
        <div class="order_date">
          <span>주문일</span>
          <strong>{{ `2019.12.24` }}</strong>
        </div>
        <div class="order_no">
          <span>주문번호</span>
          <strong>{{ `H00000000000` }}</strong>
        </div>
        <div class="shipping_fee">
          <span>배송비</span>
          <strong>{{ `2,500원` }}</strong>
        </div>
      </div>
      <div class="book_wrap">
        <input id="book_chk" v-model="bookChk" type="checkbox" name="" />
        <label
          :class="!bookChk ? '' : 'active_chk'"
          class="book_chk cursor"
          for="book_chk"
        ></label>
        <!-- <div class="thumb">
          <img
            class="book_thumb"
            src="@/assets/images/cover/temp_book_cover.jpg"
            alt=""
          />
        </div> -->
        <div class="book_info">
          <div class="book_title">책제목</div>
          <div class="book_writer">
            <span class="after_writer">작가이름</span>
            <span>분류</span>
          </div>
        </div>
        <div class="book_price">36.000원</div>
      </div>
    </div>
    <div class="body_wrap">
      <span>{{ `반품 사유` }}</span>

      <!--  -->

      <div class="select_area">
        <div class="select_item" :class="{ active: isShowSelect }">
          <button
            v-on-clickaway="closeSelectOptions"
            class="select_option"
            @click="toggleSelectOptions"
          >
            <span v-if="selectList === 0" class="txt">{{
              $t('views.cart.deliveryinfo.1977')
            }}</span>
            <span v-else>{{ selectTitle }}</span>
            <span class="arrow blind">열기</span>
          </button>
          <ul class="select_list" data-return-check="true">
            <li class="tit">
              {{ selectTitle }}
              <button type="button" class="select_list_close an_a">
                <span class="svg_close"></span>
                <span class="an_t">닫기</span>
              </button>
            </li>

            <li v-for="(data, idx) in selectOptions" :key="idx">
              <button
                type="button"
                class="list_option"
                :class="{ active: selectList === data.value }"
                @click="selectDeliveryMessage(data.value)"
              >
                <span>{{ data.title }}</span>
              </button>
            </li>
          </ul>
        </div>
      </div>

      <!--  -->

      <!-- <div class="select_wrap" @click="showSelectOptions">
        <div class="select_title">
          <span>{{ selectTitle }}</span>
          <img
            :class="isShowSelect ? 'lotate_on' : ''"
            src="../../assets/images/svg/textarea_drop_arrow_icon.svg"
            alt="화살표"
          />
        </div>

        <ul :class="isShowSelect ? 'select_box_on' : ''" class="select_box">
          <li
            v-for="(data, idx) in selectOptions"
            :key="idx"
            class="select_option"
            @click="mutationSelectOption"
          >
            {{ data.title }}
          </li>
        </ul>
      </div> -->
      <div class="return_desc_wrap">
        <textarea
          id="return_desc"
          v-model="returnDesc"
          maxlength="250"
          type="text"
          placeholder="상세사유를 알려주세요"
        />
      </div>
      <div class="text_length_wrap">
        <span>{{ `*${returnDescLength}자/ 250자` }}</span>
      </div>
    </div>
    <div class="btn_wrap">
      <div class="box_btn cursor" @click="emitCall">
        수거정보 입력
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReturnStage1',
  data() {
    return {
      selectList: false,
      returnDesc: '',
      bookChk: false,
      isShowSelect: false,

      selectOptions: [
        { title: '직접입력', value: 1 },
        { title: 'test2', value: 2 },
        { title: 'test3', value: 3 },
        { title: 'test4', value: 4 }
      ]
    }
  },
  computed: {
    setReturnReason() {
      if (this.selectOptions.find((e) => e.value === this.selectList)) {
        return this.selectOptions.find((e) => e.value === this.selectList)
      } else {
        return false
      }
    },
    setReturnDescription() {
      return this.returnDesc
    },
    selectTitle() {
      if (this.selectOptions.find((e) => e.value === this.selectList)) {
        return this.selectOptions.find((e) => e.value === this.selectList).title
      } else {
        return ''
      }
    },
    returnDescLength() {
      return this.returnDesc.length
    }
  },
  methods: {
    showSelectOptions() {
      this.isShowSelect = !this.isShowSelect
    },
    mutationSelectOption() {
      // console.log('f')
    },
    toggleSelectOptions() {
      this.isShowSelect = true
    },
    closeSelectOptions() {
      this.isShowSelect = false
    },

    selectDeliveryMessage(value) {
      this.selectList = value
      this.showInputMessage = false
    },
    emitCall() {
      if (!this.setReturnReason || !this.setReturnDescription) {
        return
      }
      const { setReturnReason, setReturnDescription } = this
      this.$emit('nextCall', {
        stageNo: 1,
        stageVal: { setReturnReason, setReturnDescription }
      })
    }
  }
}
</script>

<style scoped lang="scss">
#return_step_1 {
  width: 100%;
  .head_wrap {
    width: 100%;
    overflow: hidden;
    border-radius: 3px;
    .order_info {
      padding: 26px 40px;
      display: flex;
      background-color: #f0f5fa;
      .order_date,
      .order_no {
        height: 23px;
        display: flex;
        align-items: center;
        margin-right: 35px;
        strong {
          color: #125c83;
          font-size: 18px;
          font-weight: 500;
        }
        span {
          margin-right: 10px;
          color: #778899;
          font-size: 14px;
          font-weight: 400;
          //   주문일
        }
      }
      .shipping_fee {
        align-self: center;
        flex: auto;
        text-align: right;
        span {
          color: #778899;
          margin-right: 8px;
        }
      }
    }
  }
  .book_wrap {
    display: flex;
    padding: 24px 40px;
    overflow: hidden;
    #book_chk {
      display: none;
    }
    .book_chk {
      width: 32px;
      height: 32px;
      border-radius: 3px;
      // background: #f0f5fa url('../../assets/images/svg/return_chk.svg')
      //   no-repeat center;
      transition: all 0.1s;
      margin-right: 20px;
    }
    .active_chk {
      // background: #36a5c2 url('../../assets/images/svg/return_chk_on.svg')
      //   no-repeat center;
      background-size: 18px 13px;
    }
    .book_thumb {
      width: 46px;
      height: 64px;
      overflow: hidden;
      border-radius: 3px;
      margin-right: 20px;
      img {
        height: 100%;
      }
    }
    .book_info {
      width: 400px;
      word-wrap: break-word;
      margin-right: 48px;
      .book_title {
        line-height: 30px;
        color: #222222;
        font-size: 20px;
      }
      .book_writer {
        line-height: 30px;
        height: 26px;
        span {
          margin-right: 16px;
          position: relative;
          color: #778899;
          font-size: 13px;
        }
        .after::after {
          content: '';
          width: 1px;
          height: 8px;
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translateY(-50%);
          background-color: #778899;
        }
      }
    }
    .book_price {
      display: flex;
      flex: auto;
      text-align: right;
      align-self: stretch;
      justify-content: flex-end;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .body_wrap {
    padding: 40px 0px;
    width: 100%;
    overflow: hidden;
    border-bottom: 1px solid #d6e7f1;
    margin-bottom: 40px;
    .select_area,
    .select_item,
    .select_option {
      width: 100%;
    }
    .select_area {
      margin: 12px 0px;
    }
    .tit {
      user-select: none;
      -webkit-user-select: none;
    }
    .select_option {
      width: 100%;
      height: 48px;
      border: 1px solid #d5dff3;
      border-radius: 12px;
      text-align: left;
      padding-left: 14px;

      span {
        user-select: none;
        -webkit-user-select: none;
      }
    }
    .list_option:hover {
      background-color: #f0f5fa;
    }
    .return_desc_wrap {
      border: 1px solid #d5dff3;
      border-radius: 12px;
      height: 240px;
      margin-bottom: 12px;
    }
    #return_desc {
      border: none;
      border-radius: 15px;
      width: 100%;
      height: 100%;
      line-height: 28px;
      resize: none;
      padding: 12px 16px;
    }
  }
  .btn_wrap {
    width: 100%;
    text-align: center;
    margin-bottom: 64px;
    .box_btn {
      font-size: 16px;
      line-height: 48px;
      text-align: center;
      color: #ffffff;
      border: none;
      width: 240px;
      height: 48px;
    }
  }
}
</style>
